/** ברירת מחדל למקורות הגעה (הגדרות משתמש — אנשי קשר) */
export const DEFAULT_CONTACT_ARRIVAL_SOURCES = ['פייסבוק', 'אינסטגרם', 'גוגל', 'אחר'] as const;
